var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetStampSnapshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.7 50.9H42.6001V113.81H126.7V50.9Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 35.3C10 31.7991 11.3907 28.4416 13.8662 25.9662C16.3417 23.4907 19.6991 22.1 23.2 22.1C25.4313 22.1081 27.6274 22.6571 29.6 23.7V105.3C27.6274 104.257 25.4313 103.708 23.2 103.7C19.6991 103.7 16.3417 105.091 13.8662 107.566C11.3907 110.042 10 113.399 10 116.9V35.3Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.499995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.6 92.5C106.697 92.942 106.956 93.3314 107.326 93.5909C107.697 93.8503 108.152 93.9606 108.6 93.9C109.7 93.9 110.5 93.3 110.5 92.5C110.5 91.7 110 91.5 109 91.2L108 90.9C106.5 90.6 105.8 89.9 105.8 88.8C105.8 87.7 107 86.6 108.6 86.6C110.2 86.6 111.4 87.5 111.4 88.9H110.4C110.375 88.6892 110.309 88.4854 110.205 88.3005C110.101 88.1157 109.961 87.9533 109.793 87.8231C109.626 87.6928 109.434 87.5971 109.229 87.5416C109.024 87.4862 108.81 87.472 108.6 87.5C107.6 87.5 106.9 88 106.9 88.8C106.9 89.6 107.3 89.7 108.4 90L109.2 90.2C110.9 90.7 111.5 91.3 111.5 92.4C111.5 93.5 110.4 94.8 108.6 94.8C106.8 94.8 105.7 93.9 105.6 92.5H106.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.166665,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.6 83.1V49.1",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 79.6H101.4",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6001 79.6H49.2001",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.6 115.1V106",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.9 99.9C114.091 99.9 118.3 95.6915 118.3 90.5C118.3 85.3085 114.091 81.1 108.9 81.1C103.709 81.1 99.5 85.3085 99.5 90.5C99.5 95.6915 103.709 99.9 108.9 99.9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0999 82.9C53.5926 82.9133 53.0877 82.8249 52.615 82.6399C52.1424 82.4549 51.7116 82.1771 51.3481 81.8229C50.9845 81.4687 50.6957 81.0453 50.4985 80.5776C50.3013 80.11 50.1998 79.6075 50.2 79.1C50.2 78.5878 50.3008 78.0807 50.4968 77.6075C50.6928 77.1343 50.9801 76.7044 51.3422 76.3422C51.7044 75.9801 52.1343 75.6928 52.6075 75.4968C53.0807 75.3008 53.5878 75.2 54.0999 75.2",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1 72.8999C53.0922 72.8999 52.1257 72.4996 51.413 71.7869C50.7004 71.0743 50.3 70.1077 50.3 69.0999C50.3 68.0921 50.7004 67.1256 51.413 66.4129C52.1257 65.7003 53.0922 65.2999 54.1 65.2999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 65.2999C83.5078 65.2999 84.4744 65.7003 85.187 66.4129C85.8996 67.1256 86.3 68.0921 86.3 69.0999C86.3 70.1077 85.8996 71.0743 85.187 71.7869C84.4744 72.4996 83.5078 72.8999 82.5 72.8999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 75.2C83.5169 75.226 84.4834 75.6484 85.1933 76.377C85.9032 77.1056 86.3003 78.0827 86.3 79.1C86.3 80.1078 85.8996 81.0743 85.187 81.787C84.4744 82.4996 83.5078 82.9 82.5 82.9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1001 65.3C54.1001 64.2922 54.5005 63.3256 55.2131 62.613C55.9257 61.9004 56.8923 61.5 57.9001 61.5C58.9079 61.5 59.8745 61.9004 60.5871 62.613C61.2997 63.3256 61.7001 64.2922 61.7001 65.3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64 65.3C64 64.2657 64.4109 63.2737 65.1423 62.5423C65.8737 61.8109 66.8657 61.4 67.9 61.4C68.4076 61.3998 68.91 61.5013 69.3777 61.6985C69.8453 61.8957 70.2688 62.1846 70.623 62.5481C70.9772 62.9117 71.255 63.3425 71.44 63.8151C71.6249 64.2877 71.7134 64.7927 71.7 65.3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74 65.3C73.9098 64.7424 73.9418 64.1719 74.0938 63.6279C74.2458 63.0839 74.5142 62.5795 74.8803 62.1494C75.2464 61.7193 75.7016 61.3739 76.2143 61.137C76.7271 60.9001 77.2851 60.7775 77.8499 60.7775C78.4148 60.7775 78.9728 60.9001 79.4856 61.137C79.9983 61.3739 80.4535 61.7193 80.8196 62.1494C81.1857 62.5795 81.4541 63.0839 81.6061 63.6279C81.7581 64.1719 81.7901 64.7424 81.6999 65.3",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6999 82.9C81.7901 83.4576 81.7581 84.0281 81.6061 84.5721C81.4541 85.116 81.1857 85.6205 80.8196 86.0506C80.4535 86.4807 79.9983 86.8261 79.4856 87.063C78.9728 87.2998 78.4148 87.4225 77.8499 87.4225C77.2851 87.4225 76.7271 87.2998 76.2143 87.063C75.7016 86.8261 75.2464 86.4807 74.8803 86.0506C74.5142 85.6205 74.2458 85.116 74.0938 84.5721C73.9418 84.0281 73.9098 83.4576 74 82.9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7 82.9C71.7003 83.9173 71.3032 84.8944 70.5933 85.623C69.8834 86.3516 68.9169 86.7739 67.9 86.8C66.8736 86.7747 65.8963 86.3556 65.1704 85.6297C64.4444 84.9037 64.0254 83.9264 64 82.9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7001 82.9C61.7001 83.9078 61.2997 84.8744 60.5871 85.587C59.8745 86.2997 58.9079 86.7 57.9001 86.7C56.8923 86.7 55.9257 86.2997 55.2131 85.587C54.5005 84.8744 54.1001 83.9078 54.1001 82.9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 37H140V127.9H23.5C20.255 127.9 17.1415 126.618 14.8377 124.333C12.5339 122.048 11.2263 118.945 11.2 115.7",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3 87.4V69.7H101",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101 118.1H83.3V100.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.8 100.4V118.1H114.1",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.1 69.7H131.8V87.4",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetStampSnapshot);
export default __webpack_public_path__ + "static/media/sheet_stamp_snapshot.5a3b9d940fba4f743b43e3cef532285c.svg";
export { ForwardRef as ReactComponent };